module.exports = __webpack_public_path__ + "img/A15.png";